
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.063.469l-1.149 2.82h3.367L12.04 1.797l.508-.43 3.82 3.82v.5l-3.82 3.82-.508-.429 1.258-1.508H8.234l-1.117 2.82h-.906l1.14-2.82H3.97l1.258 1.508-.508.43-3.82-3.82v-.5l3.82-3.82.508.429-1.25 1.492H9.03L10.156.47h.906zM3.163 6.53h4.578l.899-2.203H3.18l-.899 1.11.883 1.093zm10.922-2.203H9.523l-.898 2.203h5.469l.89-1.093-.898-1.11z","fill":"currentColor"}})])
          )
        }
      }
    